import styles from "./Loader.module.scss";
import {
  loaderClassNames,
  loaderSizeClassMap,
} from "./Loader.constants";
import type { LoaderProps } from "./Loader.types";
import { cn } from "../../utils/cn";

export function Loader({
  className,
  size = "lg",
  text,
  isCentered = true,
  label,
  role = "status",
  ...rest
}: LoaderProps) {
  const {
    "aria-live": ariaLiveProp,
    "aria-busy": ariaBusyProp,
    "aria-label": ariaLabelProp,
    ...divProps
  } = rest;

  const classes = cn(
    styles[loaderClassNames.base],
    styles[loaderSizeClassMap[size]],
    isCentered ? styles[loaderClassNames.centered] : null,
    className,
  );

  return (
    <div
      {...divProps}
      className={classes}
      role={role}
      aria-live={ariaLiveProp ?? "polite"}
      aria-busy={ariaBusyProp ?? true}
      aria-label={ariaLabelProp ?? (text ? undefined : label ?? "Loading")}
    >
      <span className={styles.Spinner} aria-hidden="true" />
      {text ? (
        <span className={styles.Text}>{text}</span>
      ) : null}
    </div>
  );
}
